import { QueryClient } from '@tanstack/vue-query';

// Its own module so ApiClient can clear the cache on identity changes without
// importing main.js, which boots the app.
export default new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
});
